import type { AssetType, ItemStatus, FixedAssetGroup, ItemRequestStatus, InventorySubtype } from "./types";

export const ASSET_TYPE_LABELS: Record<AssetType, { ru: string; en: string; kk: string }> = {
  inventory: { ru: "Товары", en: "Goods", kk: "Тауарлар" },
  fixed_asset: { ru: "Основные средства", en: "Fixed Assets", kk: "Негізгі құралдар" },
  intangible: { ru: "Нематериальные активы", en: "Intangible Assets", kk: "Мәдени емес активтер" },
  service: { ru: "Услуги", en: "Services", kk: "Қызметтер" },
};

export const STATUS_LABELS: Record<ItemStatus, { ru: string; en: string; kk: string }> = {
  in_stock: { ru: "На складе", en: "In Stock", kk: "Қоймада" },
  assigned: { ru: "Выдан работнику", en: "Assigned", kk: "Қызметкерге берілген" },
  written_off: { ru: "Списан", en: "Written Off", kk: "Есептен шығарылған" },
  disposed: { ru: "Выбыл", en: "Disposed", kk: "Шыққан" },
};

export const INVENTORY_SUBTYPE_LABELS: Record<NonNullable<InventorySubtype>, { ru: string; en: string; kk: string }> = {
  consumable: { ru: "Расходный материал", en: "Consumable", kk: "Шығын материалы" },
  reusable: { ru: "Многоразовый", en: "Reusable", kk: "Көп рет қолданылатын" },
};

export const FIXED_ASSET_GROUP_LABELS: Record<FixedAssetGroup, { ru: string; en: string; kk: string }> = {
  group1: { ru: "Здания, сооружения", en: "Buildings", kk: "Ғимараттар" },
  group2: { ru: "Машины, оборудование", en: "Machinery", kk: "Машиналар" },
  group3: { ru: "Компьютеры, оргтехника", en: "Computers", kk: "Компьютерлер" },
  group4: { ru: "Транспорт", en: "Transport", kk: "Көлік" },
  other: { ru: "Прочие", en: "Other", kk: "Басқа" },
};

export function isFixedRateGroup(group: string | null | undefined): boolean {
  return group === "group1" || group === "group2" || group === "group3" || group === "group4";
}

export const FIXED_ASSET_GROUP_DEFAULTS: Record<FixedAssetGroup, { rate: number; months: number }> = {
  group1: { rate: 0.10, months: 120 },
  group2: { rate: 0.25, months: 48 },
  group3: { rate: 0.40, months: 30 },
  group4: { rate: 0.15, months: 80 },
  other: { rate: 0.15, months: 80 },
};

export const ITEM_REQUEST_STATUS_LABELS: Record<ItemRequestStatus, { ru: string; en: string; kk: string }> = {
  pending: { ru: "Ожидает подтверждения", en: "Pending Confirmation", kk: "Растауды күтуде" },
  approved: { ru: "Ожидает выдачи", en: "Pending Issuance", kk: "Беруді күтуде" },
  rejected: { ru: "Отклонена", en: "Rejected", kk: "Қабылданбады" },
  fulfilling: { ru: "В процессе выдачи", en: "Fulfilling", kk: "Беру барысында" },
  fulfilled: { ru: "Выполнена", en: "Fulfilled", kk: "Орындалды" },
  cancelled: { ru: "Отменена", en: "Cancelled", kk: "Болдырмау" },
  unavailable: { ru: "Нет в наличии", en: "Unavailable", kk: "Қолжетімсіз" },
};
